import i18n from "../../../helpers/i18n";

export const normalizeWineCharacteristicValue = (value: number | null | undefined): number => {
  switch (value) {
    case 1:
      return 0;
    case 3:
      return 1;
    default:
      return 0.5;
  }
};

export const radioIconWidth = 25;
export const radioIconMiddleValue = 0.5;

export const alcoholPercentageQueryLabels = [
  {
    id: 1,
    shortName: i18n.t("myTasteProfile:alcohol.low"),
  },
  {
    id: 2,
    shortName: i18n.t("myTasteProfile:alcohol.medium"),
  },
  {
    id: 3,
    shortName: i18n.t("myTasteProfile:alcohol.high"),
  },
];
